module.exports = __webpack_public_path__ + "img/insurance.efae12af.svg";